import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { LoginPayload, LoginState } from './types';

export const initialState: LoginState = {
  loading: false,
  isLoggedIn: false,
};

export const loginSlice = createSlice({
  name: 'login',
  initialState,
  reducers: {
    login(state, action: PayloadAction<LoginPayload>) {
      state.loading = true;
      state.isLoggedIn = false;
    },
    loginSucceeded(state, action: PayloadAction<any>) {
      state.loading = false;
      state.isLoggedIn = true;
    },
    loginFailed(state) {
      state.loading = false;
      state.isLoggedIn = false;
    },
  },
});

export const { actions: loginActions } = loginSlice;

export const useLoginSlice = () => {
  return { actions: loginSlice.actions };
};
